import { AxiosResponse } from 'axios';

import Resolver from 'src/common/Resolver';
import useSystemOptionsStore from 'src/stores/systemOptionsStore';
import useTrackMapsStore from 'src/stores/trackMapsStore';
import TrackMaps from './TrackMaps';

const TrackMapsResolver = () => {
  const { fetchTrackMaps: doFetchTrackMaps } = useTrackMapsStore(trackMapsState => trackMapsState);
  const { fetchDistances: doFetchDistances } = useSystemOptionsStore(systemOptionsState => systemOptionsState);

  const loadDependencies = () => {
    const deps: Array<Promise<void | AxiosResponse<unknown>>> = [
      doFetchTrackMaps(),
      doFetchDistances(),
    ];

    return Promise.all(deps);
  };

  return <Resolver resolve={loadDependencies} successComponent={TrackMaps} />;
};

export default TrackMapsResolver;
